import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { GameRankingChangeData } from '@features/games/models/game-ranking-change-data';
import { GameRankingData } from '@features/games/models/game-ranking-data';
import { GameRankingDetailsData } from '@features/games/models/game-ranking-details-data';
import { GameRankingResetData } from '@features/games/models/game-ranking-reset-data';
import { BehaviorSubject, Observable, Subject, tap } from 'rxjs';

@Injectable()
export class GameRankingService {

  private rankingDetailsUrl = '/games/gamedetails/{id}/ranking';  
  private rankingChangeUrl = '/games/gameranking'; 
  private rankingResetUrl = '/games/gameranking/reset';

  private http = inject(HttpClient);

  private gameRankingListSubject$ = new BehaviorSubject<GameRankingData[] | undefined>(undefined);
  private rankingChangedSubject$ = new Subject<GameRankingData[]>();
  
  public get gameRankingList$() : Observable<GameRankingData[] | undefined> {
    return this.gameRankingListSubject$.asObservable();
  }
  public get rankingChange$() : Observable<GameRankingData[]> {
    return this.rankingChangedSubject$.asObservable();
  }
  
  constructor() { }

  public getRankingDetails(gameDetailsId: string): Observable<GameRankingDetailsData> {
    return this.http.get<GameRankingDetailsData>(this.rankingDetailsUrl.replace('{id}', gameDetailsId)).pipe(
      tap(gameRankingDetails => {
        this.gameRankingListSubject$.next(gameRankingDetails?.gameRankingList);
      })
    );
  }

  public setRankingList(gameRankingChanges: GameRankingChangeData) : Observable<GameRankingChangeData> {
    this.rankingChangedSubject$.next(gameRankingChanges.gameRankingList);
    
    return this.http.post<GameRankingChangeData>(this.rankingChangeUrl, gameRankingChanges);
  }

  public resetRankingList(gameRankingReset: GameRankingResetData) : Observable<void> {
    return this.http.post<void>(this.rankingResetUrl, gameRankingReset);
  }

}
